angular.module('unergie.main')
.directive('eventrules', ($uibModal, ErrorCatcher) =>
    ({
        restrict: 'E',
        templateUrl: '/directives/eventrules/eventrules.html',
        scope: {
            resource: '=',
            id: '=',
        },
        link($scope) {
            $scope.openEventRulesModal = function () {
                const modalInstance = $uibModal.open({
                    animation: true,
                    size: 'lg',
                    controller: 'eventRulesModalCtrl',
                    templateUrl: '/states/eventRulesModal/eventRulesModal.html',
                    resolve: {
                        resource() {
                            return $scope.resource
                        },
                        id() {
                            return $scope.id
                        },
                    },
                })
                return modalInstance.closed.then((result) => {})
            }
        },
    }),
)
